import { Injectable, Type } from '@angular/core';

import { Product } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

import { BaseRestrictionCommand } from './base-restriction.command';
import { DisableParameterChangesInlineComponent } from './components/disable-parameter-changes-inline/disable-parameter-changes-inline.component';
import { RestrictionCommandResult } from './restriction-command.interface';

@Injectable({ providedIn: 'root' })
export class DisableParameterChangesCommand extends BaseRestrictionCommand {
  readonly type = 'disableParameterChanges';
  readonly title = 'Запретить изменение параметров через ДБО';
  readonly icon = 'settings';
  readonly isDangerous = true; // Красный цвет
  readonly settingsNames = undefined;
  readonly group = 'limits';
  readonly order = 4;
  readonly isInline = true; // Указываем, что это inline компонент
  readonly inlineComponent: Type<DisableParameterChangesInlineComponent> = DisableParameterChangesInlineComponent;

  constructor(commandAvailabilityService?: CommandAvailabilityService) {
    super(commandAvailabilityService);
  }

  async execute(_context: { data: Product }): Promise<RestrictionCommandResult> {
    // Для inline компонентов execute не вызывается
    // Логика реализована в самом компоненте
    return {
      success: false,
      shouldCloseParent: false
    };
  }

}
